var _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackTimeBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1297 507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edeefc;}.cls-2{fill:#acaae2;opacity:0.25;isolation:isolate;}.cls-3{fill:#040227;}.cls-4{fill:none;}.cls-5{fill:#c5c9f6;}.cls-6{fill:#e4e5f8;}.cls-7{fill:#00a7ff;}.cls-8{fill:#fff;}.cls-9{fill:#e9a4b3;}.cls-10{fill:#09d;}.cls-11{fill:#d998a9;}.cls-12{fill:#487cd3;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Surface-2",
    className: "cls-1",
    x: 8.32,
    y: 74.89,
    width: 1280,
    height: 423,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    className: "cls-2",
    d: "M841.75,60.12a25.61,25.61,0,0,1,3.11-4.8A16.54,16.54,0,0,0,843,32a16.82,16.82,0,0,0-3.21-2.15L809.33,14.63A16.44,16.44,0,0,0,787.27,22L772.14,52.23a16.29,16.29,0,0,1-21.78,7.51,16.53,16.53,0,0,1-2.88-1.8,25.74,25.74,0,0,0-4.69-3c-15-7.52-34.56,1.08-43.62,19.21S695,113,710,120.53a25,25,0,0,0,5.24,1.94,16.31,16.31,0,0,1,11.44,20h0a17,17,0,0,1-1.22,3.15l-15.12,30.24a16.43,16.43,0,0,0,7.35,22l30.24,15.13a16.29,16.29,0,0,1,7.5,21.79,16,16,0,0,1-1.78,2.87,25,25,0,0,0-3,4.67c-7.51,15,1.09,34.55,19.21,43.62s38.9,4.22,46.42-10.8a25.48,25.48,0,0,0,1.93-5.21,16.3,16.3,0,0,1,20-11.44,15.93,15.93,0,0,1,3.14,1.21l30.24,15.12a16.44,16.44,0,0,0,22.06-7.35l15.31-30.61a16.47,16.47,0,0,1,22.14-7.26h0a16.62,16.62,0,0,1,3.4,2.29,25.68,25.68,0,0,0,5.16,3.42c15,7.51,34.56-1.08,43.62-19.21s4.22-38.9-10.8-46.42a26.14,26.14,0,0,0-5.83-2.08,16.48,16.48,0,0,1-12.69-19.54h0a17.06,17.06,0,0,1,1.34-3.87l15.31-30.61a16.44,16.44,0,0,0-7.35-22.06L933.08,76.51a16.56,16.56,0,0,0-22.31,7.14,16.74,16.74,0,0,0-1.33,3.49,25.45,25.45,0,0,1-2.06,5.79c-7.52,15-28.3,19.86-46.42,10.8S834.23,75.14,841.75,60.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    className: "cls-3",
    d: "M866.19,52.34a25.21,25.21,0,0,1,3.11-4.79,16.53,16.53,0,0,0-1.85-23.31h0a16.51,16.51,0,0,0-3.21-2.15L833.77,6.85a16.44,16.44,0,0,0-22.06,7.35L796.58,44.45A16.29,16.29,0,0,1,774.8,52a16.53,16.53,0,0,1-2.88-1.8,25.74,25.74,0,0,0-4.69-3c-15-7.52-34.56,1.08-43.62,19.21s-4.23,38.9,10.8,46.42a25.53,25.53,0,0,0,5.24,1.93,16.33,16.33,0,0,1,10.22,23.16l-15.12,30.24a16.43,16.43,0,0,0,7.35,22l30.24,15.12a16.3,16.3,0,0,1,7.5,21.8h0a15.75,15.75,0,0,1-1.79,2.86,25.83,25.83,0,0,0-3,4.67c-7.51,15,1.09,34.56,19.21,43.62s38.9,4.22,46.42-10.8a25.48,25.48,0,0,0,1.93-5.21,16.3,16.3,0,0,1,20-11.43,16.08,16.08,0,0,1,3.13,1.21L896,267.11a16.45,16.45,0,0,0,22.06-7.35l15.3-30.62a16.49,16.49,0,0,1,22.14-7.26h0a16,16,0,0,1,3.4,2.3,25.63,25.63,0,0,0,5.16,3.41c15,7.52,34.56-1.08,43.62-19.2s4.22-38.91-10.8-46.42a25.18,25.18,0,0,0-5.83-2.08,16.49,16.49,0,0,1-12.69-19.55h0a17,17,0,0,1,1.34-3.86L995,105.86a16.45,16.45,0,0,0-7.35-22.06L957.52,68.73a16.6,16.6,0,0,0-23.64,10.63,25.28,25.28,0,0,1-2.06,5.79c-7.52,15-28.3,19.87-46.42,10.8S858.67,67.37,866.19,52.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Access_Time_Sharp",
    "data-name": "Icon Access Time Sharp"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box-3",
    className: "cls-4",
    x: 803.27,
    y: 111.63,
    width: 115.17,
    height: 115.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    className: "cls-5",
    d: "M804.22,169.22a56.64,56.64,0,1,1,56.64,56.63h-.06a56.6,56.6,0,0,1-56.58-56.62Zm11.33,0a45.3,45.3,0,1,0,45.3-45.3h0a45.29,45.29,0,0,0-45.3,45.28Zm39.64,5.66v-34h8.5v29.74l25.48,15.12-4.25,7Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-6",
    d: "M1140.88,82.56s36.41,37.25,38.18,51.61S1161.51,171,1161.51,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-6",
    d: "M1124.62,477.31s-1.25,20.25-5.17,20.54c-.52,0-19.87,0-19.87,0l-24.7-.15s.16-5.95,7.38-7.21,19.3-6.33,23.68-15.87C1110.54,464.62,1124.62,477.31,1124.62,477.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-6",
    d: "M1179.63,477.31s-1.26,20.25-5.17,20.54c-.52,0-19.87,0-19.87,0l-24.7-.15s.16-5.95,7.38-7.21,19.3-6.33,23.68-15.87C1165.55,464.62,1179.63,477.31,1179.63,477.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-6",
    d: "M1097.27,259.7s6.46,41.31,30.56,114.65,27.38,105.09,27.38,105.09l25.85-.72s.22-80.15-10.89-117-2.4-132.95-2.4-132.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-6",
    d: "M1084.69,231a1004.19,1004.19,0,0,0,9.86,138.7c10.77,76.44,7.12,108.88,7.12,108.88l25.8.86s15.42-76.47,11-114.73,21.11-131.28,21.11-131.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-6",
    d: "M1134.63,85.32l-13.74,9L1101,90.63c.28-1.6,1.59-8.25,2.78-14.27.07-.35.15-.71.21-1.06,1-5.12,1.91-9.52,1.91-9.52l18.55-8.18,6.92-3.05c0,.1-.54,5.68-.61,6.5C1129.49,75.5,1134.63,85.32,1134.63,85.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-6",
    d: "M1106.11,80.78c.39-.17,23.92-7.1,26.48-6.27s4.07,5.79,4.07,5.79l-38.5,8.7S1101.19,82.84,1106.11,80.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-6",
    d: "M1169.49,238.69c-4,18.2-70.39,20.36-87.5,3.83-2-1.88-2-10.64-1.31-22.46,1.43-23.07,6-57.79,6.23-75.52a139.62,139.62,0,0,1,2.83-25.29A205.09,205.09,0,0,1,1098.16,89s32.43-10.48,38.5-8.7C1165.89,88.89,1173.48,220.49,1169.49,238.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-6",
    d: "M1080.68,220.07c1.44-23.07,6-57.79,6.23-75.53a139.51,139.51,0,0,1,2.83-25.28l19.51-3.44S1128.32,193.72,1080.68,220.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-6",
    d: "M1091.24,187.9a4.6,4.6,0,0,1-1.46,5.32c-2.79,2.13-4.6,5.59-4,8.12s6.77,6.64,8.89,6,6.45-4,6-5.33,2.9-11.7-2.27-15.68S1091.24,187.9,1091.24,187.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-6",
    d: "M1113.05,84.33s-19,3.56-34.18,25.9-25.13,39-22.34,47,28.25,36,32.64,36,11.47-3.19,11.86-10.38c0,0-17.92-26.86-14.39-30.88,1.51-1.72,23.27-19.38,26.38-11.4C1118.16,153.75,1113.05,84.33,1113.05,84.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-6",
    d: "M1129.39,61.29c-4.08,6.9-19.26,12.87-25.59,15.07.07-.36.15-.71.21-1.06,1-5.12,1.91-9.52,1.91-9.52l18.55-8.19C1128.58,57.54,1131.07,58.45,1129.39,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-6",
    d: "M1098.92,64.65s29.89,9.32,35.42-9.38,13.09-30.1-5.75-36.83-24.68-.71-28,5.08S1091.29,61.74,1098.92,64.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    className: "cls-6",
    d: "M1135.23,51a21.45,21.45,0,0,0-1.76-7,15.57,15.57,0,0,0-5.28-7c-2.91-2-5.53.06-7-1.76-2-2.37,1.75-6.78,0-8.8-1.32-1.52-4.21,0-9.59.56-4.37.44-10.8.82-14.92-2.55-3-2.47-5.09-9.19-1.84-12.55a6.05,6.05,0,0,1,7.51-1,3.94,3.94,0,0,1,1.57,2.12A21.84,21.84,0,0,1,1109.53,8a7.67,7.67,0,0,1,7.23-.43c3,1.85,2.37,6.39,5.47,8.06,1.87,1,4.45.6,6.71-.05s4.56-1.56,6.85-1.44a8,8,0,0,1,6.52,4.25,30.87,30.87,0,0,1,2.73,9.15,55.42,55.42,0,0,1,.85,7.92C1145.76,43,1137.63,49.25,1135.23,51Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111-2",
    "data-name": "Path 111-2",
    className: "cls-7",
    d: "M1119.14,82.56s36.41,37.25,38.18,51.61S1139.77,171,1139.77,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112-2",
    className: "cls-8",
    d: "M1102.88,477.31s-1.26,20.25-5.17,20.54c-.52,0-19.87,0-19.87,0l-24.7-.15s.16-5.95,7.38-7.21,19.3-6.33,23.68-15.87C1088.8,464.62,1102.88,477.31,1102.88,477.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113-2",
    "data-name": "Path 113-2",
    className: "cls-8",
    d: "M1157.89,477.31s-1.26,20.25-5.17,20.54c-.52,0-19.87,0-19.87,0l-24.7-.15s.16-5.95,7.38-7.21,19.3-6.33,23.68-15.87C1143.81,464.62,1157.89,477.31,1157.89,477.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114-2",
    "data-name": "Path 114-2",
    className: "cls-3",
    d: "M1075.53,259.7S1082,301,1106.08,374.35s27.38,105.09,27.38,105.09l25.85-.72s.23-80.15-10.88-117-2.4-132.95-2.4-132.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115-2",
    "data-name": "Path 115-2",
    className: "cls-3",
    d: "M1063,231a1002.63,1002.63,0,0,0,9.85,138.7c10.78,76.44,7.13,108.88,7.13,108.88l25.8.86s15.41-76.47,11-114.73,21.11-131.28,21.11-131.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116-2",
    "data-name": "Path 116-2",
    className: "cls-9",
    d: "M1112.89,85.32l-13.75,9-19.86-3.7c.27-1.6,1.59-8.25,2.78-14.27.07-.35.15-.71.21-1.06l1.9-9.52,18.56-8.18,6.91-3.05c0,.1-.53,5.68-.6,6.5C1107.75,75.5,1112.89,85.32,1112.89,85.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117-2",
    "data-name": "Path 117-2",
    className: "cls-10",
    d: "M1084.37,80.78c.38-.17,23.92-7.1,26.48-6.27s4.07,5.79,4.07,5.79l-38.5,8.7S1079.45,82.84,1084.37,80.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118-2",
    "data-name": "Path 118-2",
    className: "cls-7",
    d: "M1147.74,238.69c-4,18.2-70.38,20.36-87.5,3.83-1.94-1.88-2-10.64-1.31-22.46,1.44-23.07,6-57.79,6.23-75.52a141.42,141.42,0,0,1,2.83-25.29A205.12,205.12,0,0,1,1076.42,89s32.42-10.48,38.5-8.7C1144.15,88.89,1151.74,220.49,1147.74,238.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119-2",
    "data-name": "Path 119-2",
    className: "cls-10",
    d: "M1058.94,220.07c1.43-23.07,6-57.79,6.23-75.53a139.51,139.51,0,0,1,2.83-25.28l19.51-3.44S1106.58,193.72,1058.94,220.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120-2",
    "data-name": "Path 120-2",
    className: "cls-9",
    d: "M1069.5,187.9a4.59,4.59,0,0,1-1.47,5.32c-2.79,2.13-4.6,5.59-4,8.12s6.77,6.64,8.89,6,6.44-4,6-5.33,2.9-11.7-2.28-15.68S1069.5,187.9,1069.5,187.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121-2",
    "data-name": "Path 121-2",
    className: "cls-7",
    d: "M1091.31,84.33s-19,3.56-34.18,25.9-25.14,39-22.34,47,28.25,36,32.63,36,11.48-3.19,11.87-10.38c0,0-17.92-26.86-14.39-30.88,1.51-1.72,23.27-19.38,26.38-11.4C1096.41,153.75,1091.31,84.33,1091.31,84.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122-2",
    "data-name": "Path 122-2",
    className: "cls-11",
    d: "M1107.65,61.29c-4.08,6.9-19.26,12.87-25.59,15.07.07-.36.15-.71.21-1.06,1-5.12,1.91-9.52,1.91-9.52l18.55-8.19C1106.83,57.54,1109.33,58.45,1107.65,61.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123-2",
    "data-name": "Path 123-2",
    className: "cls-9",
    d: "M1077.18,64.65s29.89,9.32,35.42-9.38,13.09-30.1-5.76-36.83-24.68-.71-28,5.08S1069.55,61.74,1077.18,64.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226-2",
    "data-name": "Path 2226-2",
    className: "cls-12",
    d: "M1113.49,51a21.7,21.7,0,0,0-1.76-7,15.63,15.63,0,0,0-5.28-7c-2.91-2-5.53.06-7-1.76-2-2.37,1.75-6.78,0-8.8-1.32-1.52-4.21,0-9.59.56-4.37.44-10.8.82-14.92-2.55-3-2.47-5.09-9.19-1.84-12.55a6.07,6.07,0,0,1,7.51-1,3.94,3.94,0,0,1,1.57,2.12A21.79,21.79,0,0,1,1087.78,8a7.66,7.66,0,0,1,7.24-.43c3,1.85,2.37,6.39,5.47,8.06,1.87,1,4.45.6,6.71-.05s4.56-1.56,6.85-1.44a8,8,0,0,1,6.51,4.25,30.6,30.6,0,0,1,2.74,9.15,55.42,55.42,0,0,1,.85,7.92C1124,43,1115.89,49.25,1113.49,51Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-9",
    d: "M1076.51,39.33l-4.62,4a5.43,5.43,0,0,0-1.18,1.26,1.87,1.87,0,0,0-.21,1.67,2.29,2.29,0,0,0,.68.83,8.19,8.19,0,0,0,4,1.88"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackTimeBanner);
export default __webpack_public_path__ + "static/media/track-time-banner.0e4f54d1ea6fe22287f5c8238093c117.svg";
export { ForwardRef as ReactComponent };